module.exports = __webpack_public_path__ + "img/poly-8.f8d7a75b.png";